module.exports = __webpack_public_path__ + "img/3.074223e9.png";